module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/product-images/product-model-2-552079907d6728a362890f56aca64e40.jpg";